// frontend/packages/business-console/src/pages/MediaLibrary.jsx

import React, { useContext } from 'react';
import { Box, Alert, Typography } from '@mui/material';
import { BusinessContext } from '../contexts/BusinessContext';
import { useAuth } from '../contexts/AuthContext';
import MediaLibraryPageView from '../components/media/MediaLibraryPageView';

export default function MediaLibraryPage() {
  const { loading, error } = useContext(BusinessContext);
  const { businessId } = useAuth();

  if (loading) {
    return (
      <Box sx={{ py: 2 }}>
        <Typography variant="h6" sx={{ fontWeight: 900 }}>
          Media
        </Typography>
        <Typography variant="body2" sx={{ opacity: 0.75, mt: 1 }}>
          Loading business…
        </Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ py: 2 }}>
        <Alert severity="error">{error}</Alert>
      </Box>
    );
  }

  if (!businessId) {
    return (
      <Box sx={{ py: 2 }}>
        <Alert severity="warning">No active business selected.</Alert>
      </Box>
    );
  }

  return <MediaLibraryPageView />;
}
